export default __webpack_public_path__ + "static/media/laundry1-afterA-1920w.e19a4d7a.webp";